import { createApiService } from './createApiService'

export const artsAPI = createApiService({
    reducerPath: 'artsAPI',
    tagTypes: ['Art', 'ArtInspirations'],
    endpoints: (build: any) => ({
        getAllArts: build.mutation({
            query: () => ({
                url: `/arts`,
                method: 'GET',
            }),
        }),
        getArt: build.mutation({
            query: ({id}: {id: number}) => ({
                url: `/arts/id/${id}`,
                method: 'GET',
            })
        }),
        getArtByImdbId: build.mutation({
            query: ({imdbId}: {imdbId: string}) => ({
                url: `/arts/imdb/${imdbId}`,
                method: 'GET',
            })
        }),
        getArtsWithoutInspirations: build.query({
            query: () => '/arts/without-inspirations',
            providesTags: ['Art'],
        }),
        getArtInspirations: build.query({
            query: (artId: number) => `/arts/${artId}/inspirations`,
            providesTags: ['ArtInspirations'],
        }),
        addArtInspirations: build.mutation({
            query: ({ artId, inspirationArtIds, relationshipDescription, description }: { artId: number; inspirationArtIds: number[]; relationshipDescription?: string; description?: string }) => ({
                url: `/arts/${artId}/inspirations`,
                method: 'POST',
                body: { inspirationArtIds, relationshipDescription, description },
            }),
            invalidatesTags: ['ArtInspirations'],
        }),
        generateAndAddInspirations: build.mutation({
            query: ({ artId, ...body }: { artId: number; prompt: string; systemPrompt?: string; model?: string; temperature?: number; maxTokens?: number; autoImport?: boolean }) => ({
                url: `/arts/${artId}/inspirations/generate`,
                method: 'POST',
                body,
            }),
            invalidatesTags: ['ArtInspirations'],
        }),
        removeArtInspiration: build.mutation({
            query: ({ artId, inspirationId }: { artId: number; inspirationId: number }) => ({
                url: `/arts/${artId}/inspirations/${inspirationId}`,
                method: 'DELETE',
            }),
            invalidatesTags: ['ArtInspirations'],
        })
    }),
})

export const { 
    useGetAllArtsMutation, 
    useGetArtMutation, 
    useGetArtByImdbIdMutation,
    useGetArtsWithoutInspirationsQuery,
    useGetArtInspirationsQuery,
    useAddArtInspirationsMutation,
    useGenerateAndAddInspirationsMutation,
    useRemoveArtInspirationMutation
} = artsAPI